import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  IPurchaseInvoicePaymentsDto,
  IPurchaseInvoicePaymentsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IPurchaseInvoicePaymentsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("stores.purchaseInvoices.payments");
const postApis = createPostApi<
  IApiResponse<IPurchaseInvoicePaymentsResponse>,
  IPathBaseParam,
  IPurchaseInvoicePaymentsDto
>("stores.purchaseInvoices.payments");

const getApis = createGetApi<
  IApiResponse<IPurchaseInvoicePaymentsResponse>,
  IPathByIdParam,
  object
>("stores.purchaseInvoices.payments");

export const payments = {
  ...getAllApis,
  ...getApis,
  ...postApis,
};
